function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("style", {
  type: "text/css"
}, "\n\t.venmo-st0{fill:#FFFFFF;}\n");

var _ref3 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("path", {
  className: "venmo-st0",
  d: "M94.8,0c3.9,6.4,5.7,13.1,5.7,21.4c0,26.7-22.8,61.4-41.3,85.7H16.9L0,5.9l37-3.5l9,72.1 c8.3-13.7,18.6-35.1,18.6-49.7c0-8-1.4-13.4-3.5-17.9L94.8,0z"
}), React.createElement("path", {
  className: "venmo-st0",
  d: "M142.8,44.6c6.8,0,23.9-3.1,23.9-12.9c0-4.7-3.3-7-7.2-7C152.7,24.8,143.7,32.9,142.8,44.6z M142,63.9 c0,11.9,6.6,16.6,15.4,16.6c9.5,0,18.7-2.3,30.6-8.4l-4.5,30.4c-8.4,4.1-21.4,6.8-34.1,6.8c-32.1,0-43.6-19.5-43.6-43.8 c0-31.6,18.7-65.1,57.2-65.1c21.2,0,33.1,11.9,33.1,28.5C196.1,55.5,161.9,63.7,142,63.9z"
}), React.createElement("path", {
  className: "venmo-st0",
  d: "M302.9,23.8c0,3.9-0.6,9.5-1.2,13.2l-11.1,70.1h-36l10.1-64.3c0.2-1.7,0.8-5.3,0.8-7.2c0-4.7-2.9-5.8-6.4-5.8 c-4.7,0-9.3,2.1-12.5,3.7l-11.5,73.6h-36.2l16.5-105h31.4l0.4,8.4c7.4-4.9,17.1-10.1,31-10.1C296.4,0.4,302.9,9.8,302.9,23.8z"
}), React.createElement("path", {
  className: "venmo-st0",
  d: "M409.8,11.9c10.3-7.4,20-11.5,33.5-11.5c18.5,0,24.9,9.4,24.9,23.4c0,3.9-0.6,9.5-1.2,13.2l-11.1,70.1h-36 l10.3-65.7c0.2-1.8,0.6-3.9,0.6-5.3c0-5.3-2.9-6.4-6.4-6.4c-4.5,0-8.9,1.9-12.3,3.7L400.6,107h-36l10.3-65.7 c0.2-1.8,0.6-3.9,0.6-5.3c0-5.3-2.9-6.4-6.4-6.4c-4.7,0-9.3,2.1-12.5,3.7l-11.5,73.6h-36.2l16.5-105h31l1,8.8 c7.2-5.3,16.9-10.5,30-10.5C398.7,0.4,406.1,5.3,409.8,11.9z"
}), React.createElement("path", {
  className: "venmo-st0",
  d: "M539.9,42.5c0-8.6-2.1-14.4-8.6-14.4c-14.2,0-17.1,25.1-17.1,38c0,9.8,2.7,15.8,9.1,15.8 C536.8,81.8,539.9,55.3,539.9,42.5z M477.6,64.5c0-33.1,17.5-64.1,57.8-64.1c30.4,0,41.5,17.9,41.5,42.7 c0,32.7-17.3,66.6-58.6,66.6C487.7,109.7,477.6,89.6,477.6,64.5z"
}));

var SvgVenmoLogoWhiteSmall = function SvgVenmoLogoWhiteSmall(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 576.9 109.7",
    style: {
      enableBackground: "new 0 0 576.9 109.7"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgVenmoLogoWhiteSmall, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/venmo_logo_white_small.50966c9f.svg";
export { ForwardRef as ReactComponent };